import axios from "axios";
export const PASARELA = process.env.VUE_APP_URLPASARELA;

const getTarjetasBloqueadas = async (params) => {
  const { data } = await axios.get(
    PASARELA + "/administracion/tarjetas_bloqueadas",
    {
      params,
    }
  );
  return data;
};

const postBloqDesbloqTarjeta = async (body) => {
  const { data } = await axios.post(
    PASARELA + "/administracion/tarjetas_bloqueadas",
    body
  );
  return data;
};

export default {
  getTarjetasBloqueadas,
  postBloqDesbloqTarjeta,
};
